import styled from "styled-components";

export const Container = styled.div`
  margin: 0 auto;
  background-color: #e5f5f2;
  border-radius: 20px;

  height: 100%;
  .main-div {
    background-color: white;
    border-radius: 20px;
    @media screen and (min-width: 768px) {
      /* height: calc(-100px + 100vh); */
    }
  }
`;

export const ContentSection = styled.div`
  padding: 20px 16px 2px 16px;
  @media screen and (min-width: 768px) {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;
export const TitleWrapper = styled.div`
  width: 100%;
  margin-bottom: 20px;
  @media screen and (min-width: 768px) {
    max-width: 700px;
    margin-left: 0;
    text-align: left;
  }
`;
export const Title = styled.h3`
  color: #303030;
  margin: 0 0 12px;
  font-size: 12px;
  text-align: center;
  @media screen and (min-width: 768px) {
    text-align: left;
  }
`;
export const Subtitle = styled.h3`
  color: #142c1f;
  margin: 0 0 12px;
  font-size: 20px;
  margin: 16px 0;
  text-align: center;
  @media screen and (min-width: 768px) {
    text-align: left;
  }
`;
export const Description = styled.p`
  color: #44554c;
  text-align: center;
  @media screen and (min-width: 768px) {
    text-align: left;
  }
`;
export const SliderSection = styled.div`
  max-width: 1050px;
  /* margin: 20px 0; */
`;
export const FoodiaryContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding-bottom: 20px;
  overflow: hidden;
`;
export const RegularTitle = styled.h3`
  color: #142c1f;
  font-size: 16px;
  margin-top: 0px;
  @media screen and (min-width: 768px) {
    margin-top: 20px;
  }
`;
export const FoodiaryTile = styled.div`
  border: 1px solid #d0d5dd;
  border-radius: 16px;
  display: flex;
  gap: 10px;
  padding: 0 10px 10px;
  align-items: center;

  @media screen and (max-width: 768px) {
    padding: 10px;
    align-items: flex-start;
  }
`;
export const FoodiaryContentDiv = styled.div`
  display: flex;
  gap: 5px;
  flex-direction: column;
  width: 100%;
  h3 {
    text-align: left !important;
  }
  p {
    text-align: left !important;
    margin-bottom: 0 !important;
  }
`;
export const FoodiaryCircle = styled.div`
  width: 25px;
  height: 23px;
  background-color: #2ecf96;
  box-shadow: 0px 1px 2px #1018280d;
  border: 2px solid #ededed;
  border-radius: 17px;
  display: flex;
  justify-content: center;
  align-items: center;
  p {
    color: white;
    font-size: 14px;
    margin: 0;
    font-weight: bold;
  }
`;
